<template>
  <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
    <li class="nav-item col-12 col-md-auto" v-for="(link, i) in links" :key="i">
      <a
        class="nav-link rounded position-relative w-100"
        aria-current="page"
        data-bs-dismiss="offcanvas"
        @click="$router.push({ name: link.name })"
        :class="$route.name == link.name ? 'active disabled' : ''"
        style="cursor: pointer"
      >
        {{ $t(`nav.${link.name}`) }}
      </a>
    </li>
    <slot />
  </ul>
</template>

<script lang="ts">
import { Options, prop, Vue } from "vue-class-component";
import type { INav } from "@/config/nav/nav.config";

class Props {
  links = prop<INav[]>({ required: true, default: () => [] });
}

@Options({})
class NavLinks extends Vue.with(Props) {}
export default NavLinks;
</script>

<style lang="scss"></style>
